const RichiestaRicambi = () => import("./RichiestaRicambi");
const MagazzinoUbicazioni = () => import("./MagazzinoUbicazioni");
const Scaffalature = () => import("./Scaffalature");
const PickListBreton = () => import("./PickListBreton");
const Lamiere = () => import("./Lamiere");
const Tubi = () => import("./Tubi");
const PreparazioneOrdini = () => import("./PreparazioneOrdini");
const DdtGestione = () => import("./DdtGestione");
const DdtDettaglio = () => import("./DdtDettaglio");
const Svansi = () => import("./Svansi");
const Diagnostica = () => import("./Diagnostica");

const EtcRicevimenti = () => import("./EtcRicevimenti");
const RicFornitori = () => import("./RicFornitori");
const RicFornitore = () => import("./RicFornitore");
import store from "../../store";

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isLoggedIn) {
        next();
        return;
    }
    if (["Scaffalature", "MagazzinoUbicazioni"].includes(to.name)) next({ path: "/login", query: { next: to.fullPath } });
    else next("/login");
};

export default [
    {
        path: "/magazzino/ric_conto_lavoro/",
        name: "RicevimentoContoLavoro",
        meta: { menu: "magazzino", title: "Conto lavoro senza ODA" },
        component: () => import("./RicContoLavoro.vue"),
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/magazzino/ubicazioni/",
        redirect: to => ({ name: "MagazzinoUbicazioni", query: to.query, hash: to.hash }),
    },
    { path: "/magazzino/imballaggi/censimento/", redirect: { name: "Imballaggi", query: { scheda: "censimento" } } },
    { path: "/magazzino/imballaggi/prove/", redirect: { name: "Imballaggi", query: { scheda: "prove" } } },
    {
        path: "/magazzino/imballaggi/",
        name: "Imballaggi",
        meta: { menu: "magazzino", title: "Imballaggi e movimentazione" },
        component: () => import("./Imballaggi.vue"),
        beforeEnter: ifAuthenticated,
    },
    { path: "/magazzino/", redirect: { name: "OrdiniConsumabili" } },
    {
        path: "/magazzino/consumi-consumabili/",
        name: "AndamentiConsumabili",
        meta: { menu: "magazzino", title: "Consumi e andamenti" },
        component: () => import("./AndamentiConsumabili.vue"),
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/magazzino/ordini-consumabili/",
        name: "OrdiniConsumabili",
        meta: { menu: "magazzino", title: "Ordini Consumabili" },
        component: () => import("./OrdiniConsumabili.vue"),
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/magazzino/:numero(DDT[0-9]+)/",
        name: "DdtDettaglio",
        meta: { menu: "magazzino", title: "Dettaglio DDT" },
        component: DdtDettaglio,
        props: true,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/magazzino/diagnostica/",
        name: "DiagnosticaMagazzino",
        meta: { menu: "magazzino", title: "Diagnostica Magazzino" },
        component: Diagnostica,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/magazzino/scaffalature/",
        name: "Scaffalature",
        meta: { menu: "magazzino", title: "Gestione Scaffalature" },
        component: Scaffalature,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/magazzino/scaffalature/ubicazioni/",
        name: "MagazzinoUbicazioni",
        meta: { menu: "magazzino", title: "Scaffalature · Ubicazioni" },
        component: MagazzinoUbicazioni,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/magazzino/etc_ricevimenti/",
        name: "EtcRicevimenti",
        meta: { menu: "magazzino", title: "EtcRicevimenti" },
        component: EtcRicevimenti,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/magazzino/ric_fornitore/:codice",
        name: "ric-fornitore",
        meta: { menu: "magazzino", title: "Ricevimenti" },
        component: RicFornitore,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/magazzino/ric_fornitori/",
        name: "Ricevimenti",
        meta: { menu: "magazzino", title: "Ricevimenti" },
        component: RicFornitori,
        beforeEnter: ifAuthenticated,
    },

    {
        path: "/magazzino/picklist_breton/",
        name: "PickListBreton",
        meta: { menu: "magazzino", title: "PickList Breton" },
        component: PickListBreton,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/magazzino/lamiere/",
        name: "Lamiere",
        meta: { menu: "magazzino", title: "Lamiere" },
        component: Lamiere,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/magazzino/tubi/",
        name: "Tubi",
        meta: { menu: "magazzino", title: "Tubi" },
        component: Tubi,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/magazzino/ricambi/:categoria?",
        name: "Ricambi",
        meta: { menu: "magazzino", title: "Ricambi" },
        component: RichiestaRicambi,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/magazzino/preparazione/",
        name: "PreparazioneOrdini",
        meta: { menu: "magazzino", title: "Preparazione Ordini" },
        component: PreparazioneOrdini,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/magazzino/ddt-preparazioni/",
        name: "DdtPreparazioni",
        meta: { menu: "magazzino", title: "Gestione DDT" },
        component: DdtGestione,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/magazzino/svansi/",
        name: "Svansi",
        meta: { menu: "magazzino", title: "Svansi" },
        component: Svansi,
        beforeEnter: ifAuthenticated,
    },
];
